import { Box, Text } from '@factorialco/deprecated-design-system'
import { ShiftManagementRolesRequirementsFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import type UnassignedShiftForm from 'modules/shift_management/lib/forms/UnassignedShiftForm'

interface Props {
  form: UnassignedShiftForm
  id: number
  roles: ShiftManagementRolesRequirementsFragment[]
}

const RolesRequirements = observer(({ form, id, roles }: Props) => {
  const handleSelectRoles = (ids: unknown | unknown[]) => {
    const prevRequirements = [...form.get('staff_requirements').value]
    prevRequirements[id] = {
      ...prevRequirements[id],
      job_catalog_roles_ids: ids,
    }
    form.setValues({ staff_requirements: prevRequirements })
  }

  const roleOptions = roles.map((role) => {
    return (
      <Selector.Option
        key={role.id}
        value={role.id}
        label={role.name}
        searchValue={role.name}
        isChecked={form
          .get('staff_requirements')
          .value[id]?.job_catalog_roles_ids?.includes(role.id)}
      >
        <Box width="full" overflowY="hidden">
          <Text.Normal size="200" weight="medium" ellipsis>
            {role.name}
          </Text.Normal>
        </Box>
      </Selector.Option>
    )
  })

  return (
    <Selector.Popover
      inputStyle="tags"
      label={
        id === 0
          ? i18n.t(
              'shift_management.coverage_section.unassigned_shift.staff_requirements.role_title'
            )
          : ''
      }
      blankLabel={i18n.t(
        'shift_management.coverage_section.unassigned_shift.staff_requirements.role_placeholder'
      )}
      placeholder={i18n.t(
        'shift_management.coverage_section.unassigned_shift.staff_requirements.role_placeholder'
      )}
      maxHeight="s300"
      value={form.get('staff_requirements').value[id]?.job_catalog_roles_ids || []}
      onChange={(value: unknown | unknown[]) => handleSelectRoles(value)}
      onToggle={(isOpen) => !isOpen}
      isMultiSelect
    >
      {roleOptions}
    </Selector.Popover>
  )
})

export { RolesRequirements }
